<script>
	import Card from "./card.svelte";

	export let cards = [];
	export let onCardDrop = () => {};
	export let padding = 60;

	let cardsElement = null;
	let cardWidth = 70;
	if (window.innerWidth > 768) {
		cardWidth = 85;
	}
	if (window.innerWidth > 1020) {
		cardWidth = 95;
	}
	$: cardStyle = "";
	let cardsStyle = `
		padding-left: ${padding}px;
		padding-right: ${padding}px;
	`;

	$: if (cardsElement) {
		const computedStyle = window.getComputedStyle(cardsElement);
		const width = Number(computedStyle.width.replace("px", ""));
		const length = Math.max(cards.length, 3);
		cardStyle = `
			margin-right: ${(width - length * cardWidth)/(length - 1)}px;
		`;
	}
</script>

<div class="cards" style={cardsStyle} bind:this={cardsElement}>
	{#each cards as card, index}
		<div style={index !== cards.length - 1 ? cardStyle : ""}>
			<Card {card} {onCardDrop} width={cardWidth} />
		</div>
	{/each}
</div>

<style>
	.cards {
		display: flex;
		flex-direction: row;
		flex-grow: 1;
	}
</style>